<template>
  <CCard accent-color="warning" class="h-100 mb-0">
    <CCardHeader v-if="isShowCardHeader" class="px-3">
      <slot name="cCardHeader"></slot>
    </CCardHeader>
    <CCardBody id="table-main-card-body" class="d-flex flex-column">
      <ve-table :columns="columnsFormat" :table-data="dataAllList.list" :row-key-field-name="rowKey"
                :class="dataAllList.list.length ? 've-table-in-card h-100' : 've-table-in-card'"
                :scroll-width="dataAllList.list.length ? scrollWidth : null"
                :cell-style-option="cellStyleOptionFormat" :cell-selection-option="cellSelectionOption"
                :fixed-header="true" :border-x="true" :border-y="true"
                :expand-option="expandOption" :checkbox-option="checkboxOption"
                :row-style-option="rowStyleOption" :event-custom-option="eventCustomOption">
      </ve-table>
      <div v-if="!dataAllList.list.length" class="empty-data-list h-100">-- Không có dữ liệu --</div>
    </CCardBody>
    <CCardFooter v-if="isShowPagination">
      <cc-pagination ref="dataAllListPagination" :totalRows="dataAllList.totalRows"
                     @onChangeItemsPerPage="onChangeItemsPerPage($event)"
                     @onChangePagination="onChangePagination($event)"></cc-pagination>
    </CCardFooter>
  </CCard>
</template>

<script>
import {mapState} from 'vuex'
import {tableOptions} from '@/mixins/veTable'
import CcPagination from '@/components/common/tableList/CcPagination'
import {SHOW_TOAST_2} from '@/common/lib'
import {format} from '@/mixins/format'
import {COLUMN_ROW_INDEX, COLUMN_ROW_EXPAND, COLUMN_ROW_CHECKBOX} from '@/common/Constant'
import * as _ from 'lodash'

export default {
  name: "CcVeTable",
  mixins: [
    tableOptions,
    format
  ],
  components: {
    CcPagination
  },
  props: {
    namespace: {
      type: String
    },
    isShowPagination: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    scrollWidth: {
      type: Number,
      default: 1600
    },
    cellStyleOption: {
      type: Object
    },
    expandOption: {
      type: Object
    },
    eventCustomOption: {
      type: Object
    },
    isColumnRowIndex: {
      type: Boolean,
      default: false
    },
    isColumnExpand: {
      type: Boolean,
      default: true
    },
    isShowCardHeader: {
      type: Boolean,
      default: true
    },
    isColumnCheckbox: {
      type: Boolean,
      default: true
    }
  },
  data() {
    this.$options.computed = {
      ...this.$options.computed,
      ...mapState(this.namespace, ['dataAllList'])
    }

    return {
      dataTableSelected: [],
      columnsFormat: [],
      cellStyleOptionFormat: _.merge({
        headerCellClass: ({column}) => {
          if (['checkbox', 'expand'].includes(column.type)) {
            return 'always-w-50px'
          }
        }
      }, this.cellStyleOption)
    }
  },
  async created() {
    const _columnsDefault = []
    if (this.isColumnRowIndex) await _columnsDefault.push(COLUMN_ROW_INDEX)
    if (this.isColumnExpand) await _columnsDefault.push(COLUMN_ROW_EXPAND)
    if (this.isColumnCheckbox) await _columnsDefault.push(COLUMN_ROW_CHECKBOX)
    this.columnsFormat = await _.concat(_columnsDefault, this.columns)
  },
  methods: {
    onChangePagination(page) {
      this.$emit('onChangePagination', page)
    },
    onChangeItemsPerPage(selectedItem) {
      this.$emit('onChangeItemsPerPage', selectedItem)
    },
    showToastGetDataList(strType) {
      if (this.dataAllList.totalRows > 0) {
        SHOW_TOAST_2('success', `Danh sách có tổng số: <b>${this.fNumber(this.dataAllList.totalRows)}</b> ${strType}.`)
      } else {
        SHOW_TOAST_2('error', 'Không có dữ liệu.')
      }
    }
  },
  watch: {
    dataTableSelected(itemSelected) {
      this.$emit('itemSelectedLength', itemSelected.length)
    }
  }
}
</script>

<style scoped></style>
